import * as Yup from "yup";

import checkout from "./forms";
const {
  formField: {
    cnpj,
    cpf,
    nomeFantasia,
    razaoSocial,
    urlFacebook,
    urlInstagram,
    urlTwitter,
    urlSite,
    mediaSocialPageEvento,
    celPhone1,
    celPhone2,
    telefone,
    email,
    cep,
    logradouro,
    numero,
    bairro,
    cidade,
    uf,
    complemento,
    password,
    confirmPassword,
    tipoPessoa,
  },
} = checkout;

const baseValidate = {
  [cnpj.name]: Yup.string()
    .length(14, "CNPJ deve ter 14 digitos")
    .test(
      "oneOfRequired",
      "CNPJ é um campo obrigatório",
      (item, testContext) => {
        return testContext.parent.cnpj || testContext.parent.cpf;
      }
    ),
  [cpf.name]: Yup.string()
    .length(11, "CPF deve ter 11 digitos")
    .test(
      "oneOfRequired",
      "CPF é um campo obrigatório",
      (item, testContext) => {
        return testContext.parent.cpf || testContext.parent.cnpj;
      }
    ),
  [nomeFantasia.name]: Yup.string().required(nomeFantasia.errorMsg),
  [razaoSocial.name]: Yup.string().required(razaoSocial.errorMsg),
  [urlFacebook.name]: Yup.string(),
  [urlInstagram.name]: Yup.string(),
  [urlTwitter.name]: Yup.string(),
  [urlSite.name]: Yup.string(),
  [mediaSocialPageEvento.name]: Yup.string().required(),
  [celPhone1.name]: Yup.string()
    .required(celPhone1.errorMsg)
    .length(11, "Celular deve ter 11 digitos"),
  [celPhone2.name]: Yup.string(),
  [telefone.name]: Yup.string(),
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [cep.name]: Yup.string().required(cep.errorMsg),
  [logradouro.name]: Yup.string().required(logradouro.errorMsg),
  [numero.name]: Yup.string().required(numero.errorMsg),
  [bairro.name]: Yup.string().required(bairro.errorMsg),
  [cidade.name]: Yup.string().required(cidade.errorMsg),
  [uf.name]: Yup.string().required(uf.errorMsg),
  [complemento.name]: Yup.string(),
  [tipoPessoa.name]: Yup.string().required(tipoPessoa.errorMsg),
};

const validationsEdit = Yup.object().shape({
  ...baseValidate,
});

const validationsCreate = Yup.object().shape({
  ...baseValidate,
  [password.name]: Yup.string()
    .required(password.errorMsg)
    .min(8, password.invalidMsg),
  [confirmPassword.name]: Yup.string()
    .required(confirmPassword.errorMsg)
    .min(8, confirmPassword.invalidMsg)
    .oneOf([Yup.ref("password"), null], "Senhas não são identicas"),
});

const validatonChangePassword = Yup.object().shape({
  [password.name]: Yup.string()
    .required(password.errorMsg)
    .min(8, password.invalidMsg),
  [confirmPassword.name]: Yup.string()
    .required(confirmPassword.errorMsg)
    .min(8, confirmPassword.invalidMsg)
    .oneOf([Yup.ref("password"), null], "Senhas não são identicas"),
});

export { validationsEdit, validationsCreate, validatonChangePassword };
